import React from 'react'
import { AggregateStorePerformanceOverviewPage } from 'domains/aggregate-store-performance/pages/overview/AggregateStorePerformanceOverviewPage'
import {
  DomainRoute,
  DomainRedirect,
} from 'domains/aggregate-store-performance/utils/domain/routingComponents'
import { aggregateStorePerformanceAccessControl } from 'domains/aggregate-store-performance/access-control/aggregateStorePerformanceAccess.configuration'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
// @hygen:inject page-import

export const aggregateStorePerformanceRouter = (
  <DomainRoute
    route="aggregate-store-performance"
    accessControl={aggregateStorePerformanceAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="aggregate-store-performance-overview"
        component={AggregateStorePerformanceOverviewPage}
      />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
      <DomainRedirect
        fromRoute="aggregate-store-performance"
        toRoute="aggregate-store-performance-overview"
      />
    </DashSwitch>
  </DomainRoute>
)
